module.exports = __webpack_public_path__ + "static/sport/out3.9580268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/out3.png
// module id = IoSV
// module chunks = 0